// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gMGcQ","input":"styles_input__a4hik"};